import React from 'react';

import EditCard from '../../Components/YourDecks/EditCard/EditCard';

import Header from '../../Components/Header/Header';

const EditYourCards = () => {
  return (
    <div>
      <Header />
      <EditCard />
    </div>
  );
};

export default EditYourCards;
